var pageHeader = {
    title: "Contact Us",
    path: "/contact-us"
};
export var contactPage = {
    pageHeader: pageHeader,
};
export default contactPage;
